module.exports = __webpack_public_path__ + "media/images/common/icon/icon-ig-w-0140497e6baafb3b6de93c331690be77.svg";